import { ApiError, createAdminApi, NetworkError, type AdminApi } from '@mrigl/api-client';
import type { MessageKey } from '@mrigl/i18n';
import type { I18n } from './i18n.js';

export const api: AdminApi = createAdminApi();

const KNOWN_CODES = new Set([
  'invalid-code',
  'code-expired',
  'operator-account',
  'merchant-account',
  'too-many-requests',
  'email-unavailable',
  'unauthenticated',
  'mfa-required',
  'forbidden',
  'subscription-restricted',
  'plan-limit-reached',
  'onboarding-incomplete',
  'terms-not-accepted',
]);

/** Localized, user-facing message for any error thrown by an API call. */
export function errorMessage(t: I18n['t'], error: unknown): string {
  if (error instanceof NetworkError) return t('admin.error.network');
  if (error instanceof ApiError && KNOWN_CODES.has(error.code)) {
    const key = `admin.error.${error.code}` as MessageKey;
    return error.code === 'too-many-requests'
      ? t(key, { seconds: Math.ceil(error.retryAfterSeconds ?? 60) })
      : t(key);
  }
  return t('admin.error.generic');
}
